import { render, staticRenderFns } from "./ArticlesInput.vue?vue&type=template&id=20e84aea&"
import script from "./ArticlesInput.vue?vue&type=script&lang=js&"
export * from "./ArticlesInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports